module.exports = __webpack_public_path__ + "img/banner3_4_zh.90acf27b.png";